import React from "react";
import { TwoToneIconT } from "types/utils";

const CaretLeftOutlined = ({ fill = "var(--dark-blue)", height = "8", width = "7", containerStyles }: TwoToneIconT) => {
  return (
    <div style={{ paddingTop: "0px", paddingRight: "0px", ...containerStyles }}>
      <svg width={width} height={height} viewBox="0 0 7 8" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0.761931 3.59456C0.485402 3.79413 0.485402 4.20587 0.761931 4.40544L5.40753 7.75812C5.73821 7.99677 6.20013 7.76048 6.20013 7.35267L6.20013 0.647327C6.20013 0.239523 5.73821 0.00323558 5.40753 0.241885L0.761931 3.59456Z"
          fill={fill}
        />
      </svg>
    </div>
  );
};

export default CaretLeftOutlined;
